<template>
	<div>  
    <br /><br />    
      <v-data-table :headers="headers" id="hello" :items="objTiers" hide-actions class="elevation-1" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
        <template slot="items" slot-scope="props">
          <td width="20%" class="text-xs-right">{{ props.item.minimum }}</td>
          <td width="20%" class="text-xs-right">{{ props.item.maximum }}</td>
          <td width="20%" class="text-xs-right">R{{ props.item.total }}</td>
          <td width="20%" class="text-xs-right"><a v-if="props.item.id != 0" @click.prevent="fncEditTier(props.item)"><i class="material-icons">edit</i></a><a v-if="props.item.id == 0" @click.prevent="fncUpdateBase(props.item)"><i class="material-icons">edit</i></a></td>
          <td width="20%" class="text-xs-right"><a v-if="props.item.id != 0" @click.prevent="fncDeleteTier(props.item.id)"><i class="material-icons">delete_forever</i></a></td>
        </template>
      </v-data-table>	
	</div>
</template>

<script>
	
  import { mapGetters } from 'vuex'; 
  import Sortable from 'sortablejs';

  export default {
	name: 'RoleList',
	intRoleEdit: 0,
    data () {
		return {			
          headers: [
            { text: 'Minimum Blind', value: '', width: '20%' },
            { text: 'Maximum Blind', value: '', width: '20%' },
            { text: 'Price', value: '', width: '20%' },
            { text: 'Edit', value: '', width: '20%' },
            { text: 'Delete', value: '', width: '20%' }            
          ],
          baseAdded: false
		}
	},
    methods: {
      fncUpdateBase() {
        this.$store.dispatch('fncGetBasePriceModal');
      },
      fncEditTier(tier) {			        
        var modalDetails = { title: 'Edit Tier', component: 'modal-tier-edit', mstate: true, params: tier };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});
		},		
		fncDeleteTier (tierId) {					
			var confirmDelete = confirm('Are you sure you would like to remove this tier?');
			if( confirmDelete === true ) {
				this.$store.dispatch({
					type: 'fncTierDelete',
					tierId: tierId
				});
			}												
		},
		fncGetRolePrivs(roleId, roleName) {
			this.$store.dispatch({
				type: 'fncGetRolePrivs',
                roleId: roleId,
                roleName: roleName,
				privList: this.privList
			});
		},
        fncReorderRoles({ oldIndex, newIndex }) {       
		    this.$store.dispatch({
				type: 'fncReorderRoles',
				start: oldIndex,
				end: newIndex
          });            
        }
	},
	computed: {
		...mapGetters([						
			'objAuthorize',
            'objTiers',
            'basePrice'
		])
	},
	beforeMount() {
      this.$store.dispatch('fncPopulateTiers');		
      this.$store.dispatch('fncGetBasePrice');
    }
}	
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>